import React, { useEffect, useRef, useState } from 'react'
import { ScrollView, Platform, Dimensions, StyleSheet, KeyboardAvoidingView } from 'react-native'
import { lTextSize, MAX_CHECKOUT_HEIGHT, MAX_CHECKOUT_WIDTH } from '../../../constants/GlobalStyle'

import { useAppDispatch, useAppSelector } from '../../../state/hooks'
import Colors from '../../../constants/Colors'

import OrderConfirmed from './PlaceOrder/OrderConfirmed'
import OrderConfirmedModalWrapper from './OrderConfirmedModalWrapper'

import { setCheckoutState } from '../../../state/Slices/checkoutSlice'
import { View, Text } from '../../../components/Themed'

import GiftCardOrderConfirmed from '../../GiftCards/views/GiftCardOrderConfirmed'

type OrderConfirmedModalProps = {
	goHome?: () => void
	useProductCheckout?: boolean
	setIsOrderConfirmedModalVisible: (visible: boolean) => void
	visible: boolean
}

const SCREENS = {
	TIP: 1,
	RECEIPT: 2,
	REVIEW: 3,
	PAYMENT: 4,
	CONFIRMED: 5,
}

const OrderConfirmedModal = ({
	goHome,
	useProductCheckout = false,
	setIsOrderConfirmedModalVisible,
	visible,
}: OrderConfirmedModalProps) => {
	const { orderPlaced, awaitingTerminalInput } = useAppSelector(state => state.checkout)

	const { appDisplayOptions } = useAppSelector(state => state.settings)
	const { showTipRestaurant } = appDisplayOptions
	const { isDelivery } = useAppSelector(state => state.persisted)
	const [currentScreen, setCurrentScreen] = useState(1)
	const [contentHeight, setContentHeight] = useState(0)
	const window = Dimensions.get('window')
	const isSmallScreen = window.width < 768 || window.height < 600

	const dispatch = useAppDispatch()

	const scrollViewRef = useRef(null)

	useEffect(() => {
		dispatch(setCheckoutState({ isConfirmModalVisible: false }))
	}, [dispatch])

	return (
		<OrderConfirmedModalWrapper visible={visible}>
			<KeyboardAvoidingView
				behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
				style={[styles.container, !global.kiosk && !isSmallScreen && styles.desktopContainer]}
			>
				<View style={styles.safeArea}>
					<ScrollView
						ref={scrollViewRef}
						contentContainerStyle={styles.scrollContent}
						keyboardShouldPersistTaps="handled"
						onContentSizeChange={(w, h) => setContentHeight(h)}
					>
						<View style={styles.content}>
							<Text style={styles.screenNumber}>
								{orderPlaced
									? useProductCheckout || (!showTipRestaurant && !isDelivery)
										? `4. ORDER CONFIRMED`
										: `5. ORDER CONFIRMED`
									: `${useProductCheckout || (!showTipRestaurant && !isDelivery) ? currentScreen - 1 : currentScreen}. ${getScreenTitle(awaitingTerminalInput && global.kiosk ? currentScreen + 1 : currentScreen)}`}
							</Text>
							<View style={styles.screenContainer}>
								{useProductCheckout ? (
									<GiftCardOrderConfirmed
										goHome={goHome}
										setIsOrderConfirmedModalVisible={setIsOrderConfirmedModalVisible}
									/>
								) : (
									<OrderConfirmed
										setIsOrderConfirmedModalVisible={setIsOrderConfirmedModalVisible}
									/>
								)}
							</View>
						</View>
					</ScrollView>
				</View>
			</KeyboardAvoidingView>
		</OrderConfirmedModalWrapper>
	)
}

const getScreenTitle = screen => {
	switch (screen) {
		case SCREENS.TIP:
			return 'TIP OPTIONS'
		case SCREENS.RECEIPT:
			return 'BASIC INFORMATION'
		case SCREENS.REVIEW:
			return 'REVIEW ORDER'
		case SCREENS.PAYMENT:
			return 'PAYMENT'
		default:
			return ''
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white',
		width: '100%',
	},
	desktopContainer: {
		maxWidth: MAX_CHECKOUT_WIDTH * 0.8,
		maxHeight: MAX_CHECKOUT_HEIGHT * 0.9,
		borderRadius: 12,
		overflow: 'hidden',
		width: '60%',
		height: '90%',
	},

	safeArea: {
		flex: 1,
		paddingTop: 10,
	},
	scrollContent: {
		flexGrow: 1,
	},
	content: {
		flex: 1,
		padding: 25,
	},

	screenNumber: {
		fontSize: 24,
		fontWeight: 'bold',
		marginBottom: 25,
		textAlign: 'left',
		letterSpacing: 1.1,
	},
	screenContainer: {
		flex: 1,
		justifyContent: 'space-between',
	},
})

export default OrderConfirmedModal
